import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { Mark } from "./Logo";
import { MaskLines } from "./Reveal";
import { ventures } from "../data/ventures";

export const Footer = () => (
  <footer id="contact" data-testid="site-footer" className="relative overflow-hidden bg-ink px-5 pb-10 pt-28 text-bone md:px-10">
    <div className="mx-auto max-w-[1500px]">
      <p className="eyebrow text-ember">Get in touch</p>
      <h2 className="mt-6 font-display text-5xl font-extrabold uppercase leading-[0.9] tracking-tight sm:text-7xl lg:text-[8.5rem]">
        <MaskLines lines={["Let's build", <span key="s" className="font-serif font-normal normal-case italic text-ember">something good.</span>]} />
      </h2>
      <div className="mt-12 flex flex-wrap gap-4">
      <a
        href="mailto:consultant@jeremyspear.com"
        data-testid="footer-email-link"
        className="group inline-flex items-center gap-4 rounded-full bg-bone px-7 py-4 font-mono text-sm uppercase tracking-[0.14em] text-ink transition-colors duration-300 hover:bg-ember hover:text-bone"
      >
        consultant@jeremyspear.com
        <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </a>
      <a
        href="tel:+13615637047"
        data-testid="footer-phone-link"
        className="group inline-flex items-center gap-4 rounded-full border border-bone/25 px-7 py-4 font-mono text-sm uppercase tracking-[0.14em] text-bone transition-colors duration-300 hover:border-ember hover:text-ember"
      >
        <Phone size={16} />
        (361) 563-7047
      </a>
      </div>

      <div className="mt-24 grid gap-10 border-t border-bone/10 pt-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <Mark className="h-9 w-9 text-ember" />
            <span className="font-display text-xl font-extrabold uppercase tracking-[0.18em]">Jeremy Spear</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-bone/70">
            Serial entrepreneur. Building companies that solve real problems — and causes that give back.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 md:col-span-7">
          {ventures.map((v) => (
            <Link
              key={v.slug}
              to={`/ventures/${v.slug}`}
              data-testid={`footer-link-${v.slug}`}
              className="group flex items-center justify-between border-b border-bone/10 py-3 text-bone/80 transition-colors hover:text-bone"
            >
              <span className="font-display text-lg font-bold uppercase tracking-tight">{v.name}</span>
              <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-bone/55 group-hover:text-ember">{v.kind}</span>
            </Link>
          ))}
        </div>
      </div>
      <div className="mt-14 flex flex-col justify-between gap-3 font-mono text-[12px] uppercase tracking-[0.16em] text-bone/55 sm:flex-row">
        <span>© {new Date().getFullYear()} Jeremy Spear</span>
        <span>Companies &amp; causes</span>
      </div>
    </div>
  </footer>
);
